import { render } from "./textarea.vue?vue&type=template&id=61206bb7&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import "./textarea.vue?vue&type=style&index=0&id=61206bb7&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src219439891/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61206bb7"]])

export default __exports__